import React from 'react';
import PropTypes from 'prop-types';
import { CHILDREN_PROP_TYPES } from 'propTypes/childrenPropTypes';
import { MENU_HERO_GRADIENT_OVERLAY } from 'constants/gradient';
import { useOnlineOrderingDisplayLocationInformationOnLayout } from 'hooks/useDisplayLocationInformationOnLayout';
import StandardMenuHeroLocationInformation from 'bento-ordering/menus/components/StandardMenuHeroLocationInformation';
import { useIsMobile } from 'styles/hooks/mediaQueries';
import BaseScreenHero from 'bento-ordering/base/components/BaseScreenHero';
import { getHasHeroImage } from 'helpers/getHasHeroImage';
import { Container } from 'components/Containers';

function StandardScreenHero({ heroImage, heroContent }) {
  const shouldDisplayLocationInformationOnLayout = useOnlineOrderingDisplayLocationInformationOnLayout();
  const isMobile = useIsMobile();

  const coverOwnState = () => {
    let styles = {};

    if (shouldDisplayLocationInformationOnLayout && !isMobile) {
      styles = {
        '&::after': {
          content: '""',
          backgroundImage: MENU_HERO_GRADIENT_OVERLAY,
          position: 'absolute',
          left: 0,
          top: 0,
          width: '100%',
          height: '100%'
        }
      };
    }

    return styles;
  };

  const hasHeroImage = getHasHeroImage(heroImage);
  const LocationInformation = shouldDisplayLocationInformationOnLayout
    ? StandardMenuHeroLocationInformation
    : null;

  return (
    <BaseScreenHero
      HeroContainerProps={{
        hasHeroImage
      }}
      HeroProps={{
        image: heroImage,
        CoverProps: {
          ownState: {
            cover: coverOwnState
          }
        }
      }}
      heroContent={heroContent}
    >
      <Container>{LocationInformation && <LocationInformation />}</Container>
    </BaseScreenHero>
  );
}

StandardScreenHero.propTypes = {
  heroImage: PropTypes.object,
  heroContent: CHILDREN_PROP_TYPES
};

export default StandardScreenHero;
